var map = {
	"./Bar/Big.svg": 87369,
	"./Bar/Huge.svg": 72508,
	"./Bar/Micro.svg": 5253,
	"./Bar/Small.svg": 70133,
	"./Check/Big.svg": 427,
	"./Check/Huge.svg": 17361,
	"./Check/Micro.svg": 12675,
	"./Check/Small.svg": 12276,
	"./Cross/Big.svg": 86815,
	"./Cross/Huge.svg": 17901,
	"./Cross/Micro.svg": 40427,
	"./Cross/Small.svg": 88966,
	"./Node/Big.svg": 89333,
	"./Node/Huge.svg": 1257,
	"./Node/Micro.svg": 99346,
	"./Node/Small.svg": 53290,
	"./Ring/Big.svg": 32959,
	"./Ring/Huge.svg": 89401,
	"./Ring/Micro.svg": 87665,
	"./Ring/Small.svg": 25688,
	"./Spinner/Big.svg": 62432,
	"./Spinner/Huge.svg": 18991,
	"./Spinner/Micro.svg": 66193,
	"./Spinner/Small.svg": 46193,
	"./Triangle/Big.svg": 37526,
	"./Triangle/Huge.svg": 37894,
	"./Triangle/Micro.svg": 59336,
	"./Triangle/Small.svg": 89733,
	"./WeirdBurger/Big.svg": 78334,
	"./WeirdBurger/Huge.svg": 24189,
	"./WeirdBurger/Micro.svg": 79458,
	"./WeirdBurger/Small.svg": 26139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86474;